import React from 'react';
import c from 'classnames';
import { css } from 'emotion';
import { withTheme } from 'emotion-theming';
import { AccentButton } from '@lyearn-team/frontend-components';

const s = {
  button: theme => css`
    color: ${theme.color.black3} !important;
    svg {
      fill: ${theme.color.black3} !important;
    }

    &:hover {
      color: ${theme.color.grey2} !important;

      svg {
        fill: ${theme.color.accentHover} !important;
      }
    }
  `
};

function LearnerAccentButton(props) {
  const { className, theme, ...otherProps } = props;

  return <AccentButton className={c(s.button(theme), className)} {...otherProps} />;
}

export default withTheme(LearnerAccentButton);
